// src/Components/admin/RequireAdmin.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function RequireAdmin({ children }) {
  const loc = useLocation();

  // Whitelist admin login path — do not guard it
  if (loc.pathname === "/admin/login") {
    return children;
  }

  try {
    const adminRaw = localStorage.getItem("admin_user");
    if (adminRaw) {
      const admin = JSON.parse(adminRaw);
      if (admin && (admin.role === "admin" || String(admin.role).includes("admin"))) {
        return children;
      }
    }

    const userRaw = localStorage.getItem("user");
    if (userRaw) {
      const user = JSON.parse(userRaw);
      if (user && String(user.role).includes("admin")) {
        return children;
      }
    }
  } catch (e) {
    // ignore parse errors
    // console.error(e);
  }

  // Not an admin — send to admin login
  return <Navigate to="/admin/login" replace />;
}
